import { format, parseISO } from 'date-fns';
import { types } from 'mobx-state-tree';
import { model, Model } from 'mst-collection';

import { formatCurrencyToGBP } from '@utils';

export class Credits extends Model({
  id: types.number,
  name: types.string,
  count: types.number,
  price: types.maybeNull(types.number),
  expirationDate: types.string,
}) {
  decreaseCount() {
    if (this.count > 0) {
      this.count -= 1;
    }
  }

  get formattedExpirationTime(): string {
    if (!this?.expirationDate) {
      return '';
    }
    return format(parseISO(this.expirationDate), 'd MMMM yyyy');
  }

  get formattedPrice() {
    if (!this.price) {
      return '';
    } else {
      return formatCurrencyToGBP(this.price.toString());
    }
  }
}

export const CreditsModel = model(Credits);
